/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IVisitor } from '../../visitors/IVisitor';

/**
 * Models an External Documentation node.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export abstract class ExternalDocumentation extends ExtensibleNode {
    public description : string;

    public url : string;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitExternalDocumentation(this);
    }

    constructor() {
        super();
        if(this.description===undefined) this.description = null;
        if(this.url===undefined) this.url = null;
    }
}
ExternalDocumentation["__class"] = "io.apicurio.datamodels.core.models.common.ExternalDocumentation";
ExternalDocumentation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




